import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { SvgWrapperComponent } from '../svg-wrapper/svg-wrapper.component';

export interface PageHeaderButton {
  label: string;
  icon?: string;  // SVG icon path (e.g., 'project-icons/share')
  onClick: () => void;
  disabled?: boolean | (() => boolean);  // Can be static boolean or function
  type?: 'primary' | 'secondary';
}

export type PageHeaderMode = 'editor' | 'view';

@Component({
  selector: 'q-page-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatToolbarModule,
    MatTooltipModule,
    TranslocoModule,
    SvgWrapperComponent
  ],
  templateUrl: './editor-toolbar.component.html',
  styleUrl: './editor-toolbar.component.scss'
})
export class PageHeaderComponent {
  /** Mode: 'editor' shows mat-toolbar with back button, 'view' shows simple header */
  mode = input<PageHeaderMode>('editor');

  /** Title to display (only for editor mode) */
  title = input<string>('');

  /** Whether to show the back button (only for editor mode) */
  showBackButton = input(true);

  /** Action buttons to display on the right */
  buttons = input<PageHeaderButton[]>([]);

  /** Emits when back button is clicked (only for editor mode) */
  backClick = output<void>();

  onBackClick(): void {
    this.backClick.emit();
  }

  /**
   * Evaluates the disabled state of a button
   * Handles both boolean values and functions
   */
  isButtonDisabled(button: PageHeaderButton): boolean {
    if (typeof button.disabled === 'function') {
      return button.disabled();
    }
    return button.disabled || false;
  }
}


